<template>
  <main class="app-content" v-if="showPage">
    <navigation-bar></navigation-bar>
    <router-view></router-view>
  </main>
</template>
<script>
import NavigationPerimeters from '../../configs/Perimeters/navigation';
import NavigationBar from '../../components/CampaignTools/NavigationBar';

export default {
  data() {
    return {
      campaign: null,
    };
  },
  components: {
    NavigationBar,
  },
  computed: {
    showPage() {
      return NavigationPerimeters.isAllowed('useAdminTool');
    },
  },
};
</script>
